import { useState } from "react";
import LabReferral from "./LabReferralbroker";
import IPDReferral from "./IPDReferralbroker";
import PHARReferral from "./PHARReferral";
import IPDAmountParts from "./IPDAmountParts";

const DoctorReferral = () => {
  // main tab: "doctorReferral" (has inner tabs) or "ipdAmountParts" (separate)
  const [activeMainTab, setActiveMainTab] = useState("doctorReferral");
  // inner tab inside Doctor Referral (one of 'lab'|'ipd'|'pharmacy')
  const [activeSubTab, setActiveSubTab] = useState("lab");

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header">
                <h5 className="card-title mb-0">Broker Accounts</h5>
              </div>

              <div className="card-body">
                {/* Main Tabs */}
                <ul className="nav nav-tabs nav-tabs-custom nav-success mb-3" role="tablist">
                  <li className="nav-item">
                    <a
                      href="#"
                      role="tab"
                      onClick={(e) => { e.preventDefault(); setActiveMainTab("doctorReferral"); }}
                      className={`nav-link ${activeMainTab === "doctorReferral" ? "active" : ""}`}
                    >
                      <i className="ri-user-line me-1 align-bottom"></i>
                      Broker Referral
                    </a>
                  </li>

                 
                </ul>

                {/* Main tab panels */}
                <div className="tab-content">
                  {/* Doctor Referral panel (contains inner tabs) */}
                  {activeMainTab === "doctorReferral" && (
                    <div className="tab-pane active">
                      {/* Inner tabs (Lab / IPD / Pharmacy) */}
                      <ul className="nav nav-pills nav-primary mb-3" role="tablist">
                        <li className="nav-item">
                          <a
                            href="#"
                            role="tab"
                            onClick={(e) => { e.preventDefault(); setActiveSubTab("lab"); }}
                            className={`nav-link ${activeSubTab === "lab" ? "active" : ""}`}
                          >
                            <i className="ri-test-tube-line me-1 align-bottom"></i>
                            Lab
                          </a>
                        </li>

                        <li className="nav-item">
                          <a
                            href="#"
                            role="tab"
                            onClick={(e) => { e.preventDefault(); setActiveSubTab("ipd"); }}
                            className={`nav-link ${activeSubTab === "ipd" ? "active" : ""}`}
                          >
                            <i className="ri-hospital-line me-1 align-bottom"></i>
                            IPD
                          </a>
                        </li>

                        {/* <li className="nav-item">
                          <a
                            href="#"
                            role="tab"
                            onClick={(e) => { e.preventDefault(); setActiveSubTab("pharmacy"); }}
                            className={`nav-link ${activeSubTab === "pharmacy" ? "active" : ""}`}
                          >
                            <i className="ri-medicine-bottle-line me-1 align-bottom"></i>
                            Pharmacy
                          </a>
                        </li> */}
                      </ul>

                      {/* Inner tab content */}
                      <div className="tab-content">
                        {activeSubTab === "lab" && <LabReferral />}
                        {activeSubTab === "ipd" && <IPDReferral />}
                        {activeSubTab === "pharmacy" && <PHARReferral />}
                      </div>
                    </div>
                  )}

                 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
  );
};

export default DoctorReferral;
